import * as types from "./mutation_types";
import axios from "axios";
import { CSRF_TOKEN } from "@/common/csrf_token";

export const reset = ({ commit }) => {
  commit(types.INSCRIPTIONETB__CREATE_RESET);
};

export const create = ({ commit }, values) => {
  axios.defaults.headers.common = {
    "X-CSRFTOKEN": CSRF_TOKEN,
  };
  commit(types.INSCRIPTIONETB__CREATE_SET_ERROR, "");
  commit(types.INSCRIPTIONETB__CREATE_TOGGLE_LOADING);
  axios
    .post("/api/sessionEtb/", values)
    .then(() => {
      commit(types.INSCRIPTIONETB__CREATE_SET_CREATED, true);
      commit(types.INSCRIPTIONETB__CREATE_TOGGLE_LOADING);
    })
    .catch((e) => {
      commit(types.INSCRIPTIONETB__CREATE_TOGGLE_LOADING);
      commit(types.INSCRIPTIONETB__CREATE_SET_ERROR, e.message);
    });
};
